jQuery(document).ready(function($) {
    $('.stories__content__slider').slick({
        appendArrows: $('.stories__arrows'),
        prevArrow: '<a href="#" class="slick-prev"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        nextArrow: '<a href="#" class="slick-next"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        speed: 800,
        fade: true,
        asNavFor: '.stories__images__slider'
    });
    $('.stories__images__slider').slick({
        speed: 800,
        arrows: false,
        asNavFor: '.stories__content__slider'
    });
    $('.stories__content__slider').on('afterChange', function(slick, currentSlide) {
        $('.stories__nav .stories__nav__item').removeClass('active');
        $('.stories__nav .stories__nav__item:nth-child('+currentSlide.currentSlide+')').addClass('active');
    });

    //Remove bottom margin
    //
    if(!isMobile) {
        var textHeight = $('.stories__content__row').outerHeight();
        $('.stories__content__row').css('margin-bottom', -textHeight/3); 
    }
});

$(document).on('click', '.stories__nav__item', function(event) {
    event.preventDefault();
    var slide = $(this).attr('data-slide');
    $('.stories__nav__item.active').removeClass('active');
    $(this).addClass('active');
    $('.stories__content__slider').slick('slickGoTo', slide);
});
